if (!customElements.get('td-list-collection')) {

  class TDListCollection extends HTMLElement {
    constructor() {
      super()
      this.OPTION_SELECTOR = '.td--collection-card__wrapper'
      this.CONTAINER_SELECTOR = '.td--collection-list__wrapper'
      this.SLIDEOUT_TRIGGER_SELECTOR = '.td--filter-sort__trigger'
      this.REPLACEMENT_SELECTOR = '[data-replacement]'

      this.sortOption = ''
      this.comparisonSet = []
      this.visibleOptions = []
      this.filterSet = []

      this.container =undefined 
      this.options = undefined
      this.slideoutTrigger = undefined
      this.replacementContainer = undefined
    }
    connectedCallback() {
      document.addEventListener('DOMContentLoaded', () => {
        // NOTE this is to handle a legacy Firefox bug
        setTimeout(() => {
          this.options = this.querySelectorAll(this.OPTION_SELECTOR)
          this.container = this.querySelector(this.CONTAINER_SELECTOR)
          this.slideoutTrigger = this.querySelector(this.SLIDEOUT_TRIGGER_SELECTOR)
          this.replacementContainer = this.querySelector(this.REPLACEMENT_SELECTOR)

          if (this.container && this.options.length) {
            this.bindEventListeners()
          } else {
            console.error("TD - List Collection Elements not found")
          }
        })
      })
    }
    bindEventListeners() {
      this.addEventListener('td:compare-set', this.handleComparisonSet.bind(this))
      this.addEventListener('td:sort-set', this.handleSortSet.bind(this))
      this.addEventListener('td:filter-set', this.handleFilterSet.bind(this))
      if (this.slideoutTrigger) {
        this.slideoutTrigger.addEventListener('click', () => document.dispatchEvent(new CustomEvent("td:slideout-open")))
      }
      if (this.replacementContainer) {
        this.handleTitleReplacement()
      }
    }
    handleComparisonSet({detail}) {
      this.comparisonSet = detail.collections
      document.dispatchEvent(new CustomEvent("td:update-compare-set", {detail:{ options: this.comparisonSet }}))
      this.handleUIUpdates()
    }
    handleSortSet({detail}) {
      this.sortOption = detail.sort
      document.dispatchEvent(new CustomEvent("td:update-sort-set", {detail:{ value: this.sortOption }}))
      this.handleUIUpdates()
    }
    handleFilterSet({detail}) {
      this.filterSet = detail.type
      document.dispatchEvent(new CustomEvent("td:update-filter-set", {detail: this.filterSet }))
      this.handleUIUpdates()
    }
    handleTitleReplacement() {
      const values = this.replacementContainer.dataset.values.split(',')
          setInterval(() => {
            this.replacementContainer.addEventListener('transitionend', () => {
              const cIndex = parseInt(this.replacementContainer.dataset.item) + 1
              if (cIndex > values.length - 1) {
                this.replacementContainer.innerHTML = values[0]
                this.replacementContainer.setAttribute('data-item', 0)
              } else {
                this.replacementContainer.innerHTML = values[cIndex]
                this.replacementContainer.setAttribute('data-item', cIndex)
              }
              this.replacementContainer.classList.remove('td--transitioning')
            }, {once:true})
            this.replacementContainer.classList.add('td--transitioning')
          }, this.dataset.replacementTime || 1000)
    }
    handleUIUpdates() {
      let visibleOptions = [...this.options]

      if (this.filterSet.length > 0) {
        visibleOptions = []
        this.options.forEach((option) => {
          if (this.filterSet.includes(option.dataset.type)) {
            visibleOptions.push(option)
          }
        })
      }
      if (this.comparisonSet.length) {
        visibleOptions = []
        this.options.forEach((option) => {
          if (this.comparisonSet.includes(option.dataset.title)) {
            visibleOptions.push(option)
          }
        })
      }
      if (this.sortOption) {
        switch (this.sortOption) {
          case 'ALPH-ASC':
            visibleOptions.sort((optA, optB) => {
              return optA.dataset.title > optB.dataset.title ? 1 : optA.dataset.title < optB.dataset.title ? -1 : 0
            })
            break;
          case 'ALPH-DESC':
            visibleOptions.sort((optA, optB) => {
              return optA.dataset.title > optB.dataset.title ? -1 : optA.dataset.title < optB.dataset.title  ? 1 : 0
            })
            break;
          case 'FEAT':
            visibleOptions.sort((optA, optB) => {
              return parseInt(optA.dataset.order) > parseInt(optB.dataset.order) ? 1 : parseInt(optA.dataset.order) < parseInt(optB.dataset.order)  ? -1 : 0
            })
            break;
          case 'PUB-ASC':
            visibleOptions.sort((optA, optB) => {
              return new Date(optA.dataset.createdDate).getTime() > new Date(optB.dataset.createdDate).getTime() ? -1 : new Date(optA.dataset.createdDate).getTime() < new Date(optB.dataset.createdDate).getTime()  ? 1 : 0
            })
            break;
          case 'PUB-DESC':
            visibleOptions.sort((optA, optB) => {
              return new Date(optA.dataset.createdDate).getTime() > new Date(optB.dataset.createdDate).getTime() ? 1 : new Date(optA.dataset.createdDate).getTime() < new Date(optB.dataset.createdDate).getTime()  ? -1 : 0
            })
            break;
          case 'PRICE-ASC':
            visibleOptions.sort((optA, optB) => {
              return parseInt(optA.dataset.price) > parseInt(optB.dataset.price) ? 1 : parseInt(optA.dataset.price) < parseInt(optB.dataset.price)  ? -1 : 0
            })
            break;
          case 'PRICE-DESC':
            visibleOptions.sort((optA, optB) => {
              return parseInt(optA.dataset.price) > parseInt(optB.dataset.price) ? -1 : parseInt(optA.dataset.price) < parseInt(optB.dataset.price)  ? 1 : 0
            })
            break;
          default:
            visibleOptions = [...this.options]
        }
      }
      this.container.innerHTML = null
      visibleOptions.forEach((option) => this.container.appendChild(option))
      this.dispatchEvent(new CustomEvent('td:update-count',{bubbles:true,detail: {active: visibleOptions}}))
    }
  }


  customElements.define('td-list-collection', TDListCollection)
}

class TDDropdownContainer extends HTMLElement {
  constructor() {
    super()
    this.WRAPPER_SELECTOR = '.td--dropdown-wrapper'
    this.TRIGGER_SELECTOR = '.td--dropdown-trigger'

    this.trigger = undefined
    this.wrapper = undefined
    this.isOpen = false
  }
  connectedCallback() {
    setTimeout(() => {
      this.trigger = this.querySelector(this.TRIGGER_SELECTOR)
      this.wrapper = this.querySelector(this.WRAPPER_SELECTOR)
      if (this.trigger && this.wrapper) {
        this.bindDropdownEvents()
        this.initialize()
      } else {
        console.error('TD - Dropdown Container Missing Elements')
      }
      
    })
  }
  initialize() {
    // Stub
  }
  bindDropdownEvents() {
    this.trigger.addEventListener("click", this.handleDropdown.bind(this))
  }
  handleDropdown() {
    if (!this.isOpen) {
      this.openDropdown()
      document.addEventListener('click', this.maybeHandleClickOutside.bind(this))
    } else {
      this.closeDropdown()
      document.removeEventListener('click', this.maybeHandleClickOutside)
    }
    this.updateDropdownState()

  }
  maybeHandleClickOutside({target}) {
    if (!this.contains(target)) {
      this.closeDropdown()
      this.updateDropdownState()
      document.removeEventListener('click', this.maybeHandleClickOutside)
    }
  }
  openDropdown() {
    this.isOpen = true;
    this.wrapper.style.maxHeight = this.wrapper.scrollHeight + "px";
  }

  closeDropdown() {
    this.isOpen = false;
    this.wrapper.style.maxHeight = null;
  }

  updateDropdownState() {
    this.setAttribute('data-open', this.isOpen);
  }
}
  
if (!customElements.get('td-dropdown-compare-container')) {

  class TDCompareContainer extends TDDropdownContainer {
    constructor() {
      super()
      this.OPTION_SELECTOR = 'input'
      this.CLEAR_SELECTOR = '[data-clear-compare]'
      this.CLEAR_BUTTON_SELECTOR = '[data-clear-all-button]'
      this.CLOSE_BUTTON_SELECTOR = '[data-close-compare]'
      this.SUBMIT_SELECTOR = '[data-compare]'
      this.VIEW_ALL_SELECTOR = '.td--compare-container__clear-all'
      this.BUTTON_HIDDEN_CLASS = 'td--compare-container__clear-all--hidden'
      this.ACTIVE_ELM_SELECTOR = '[data-active-options-container]'
      this.ACTIVE_COUNT_SELECTOR = '[data-active-options-container-count]'

      this.viewAllButton = undefined
      this.activeCountElement = undefined
      this.options = []
      this.clearActions = []
      this.submitActions = []
      this.selectedOptions = []
    }
    initialize() {
      this.options = this.querySelectorAll(this.OPTION_SELECTOR)
      this.clearActions = this.querySelectorAll(this.CLEAR_SELECTOR)
      this.clearButton = this.querySelector(this.CLEAR_BUTTON_SELECTOR)
      this.closeButton = this.querySelector(this.CLOSE_BUTTON_SELECTOR)
      this.submitButton = this.querySelector(this.SUBMIT_SELECTOR)
      this.submitActions = this.querySelectorAll(this.SUBMIT_SELECTOR)
      this.viewAllButton = this.querySelector(this.VIEW_ALL_SELECTOR)
      this.activeCountElement = this.querySelector(this.ACTIVE_ELM_SELECTOR)
      this.currentCountElement = this.querySelector(this.ACTIVE_COUNT_SELECTOR)

      if (this.options.length && this.clearActions.length && this.submitActions.length) {
        this.bindEventListeners()
      } else {
        console.error('TD - Compare Container Missing Elements')
      }

    }
    bindEventListeners() {
      this.clearActions.forEach((trigger) => {
        trigger.addEventListener('click', this.handleClearAll.bind(this))
      })
      this.submitActions.forEach((trigger) => {
        trigger.addEventListener('click', this.handleCompare.bind(this))
      })
      this.closeButton.addEventListener('click', this.handleClose.bind(this))
      this.options.forEach((option) => option.addEventListener('change', this.handleOptionChange.bind(this,option)))
      document.addEventListener('td:global-compare-set', this.handleExternalFilterUpdate.bind(this))
      document.addEventListener('td:clear-all-filters', this.handleExternalClearAll.bind(this))
      document.addEventListener('td:update-compare-set', this.handleExternalCompareSet.bind(this))
    }
    handleOptionChange(option) {
      document.dispatchEvent(new CustomEvent('td:global-compare-set', {detail: { option }}))
      this.updateSelected()
      this.updateButtons()
    }
    handleExternalFilterUpdate({detail}) {
      const changedOption = detail.option
      const matchingOption = [...this.options].find((option) => option.value === changedOption.value)
      if (matchingOption) {
        matchingOption.checked = changedOption.checked
      }
    }
    handleClearAll() {
      this.handleFiltersCleared()
      setTimeout(() => {
        this.dispatchEvent(new CustomEvent('td:compare-set', {bubbles:true, detail: {collections: []}}))
        document.dispatchEvent(new CustomEvent('td:clear-all-filters'))
        this.updateContainerUI(true)
        this.updateSelected()
        this.updateButtons()
      }, 400);
    }
    handleClose() {
      this.handleDropdown()
    }
    handleExternalClearAll() {
      this.handleFiltersCleared()
      this.updateContainerUI(true)
    }
    updateSelected() {
      this.selectedOptions = []
      this.options.forEach((option) => {
        if (option.checked) {
          this.selectedOptions.push(option)
        }
      })
      this.updateContainerUI(true)
    }
    handleCompare() {
      this.selectedOptions = []
      this.options.forEach((option) => {
        if (option.checked) {
          this.selectedOptions.push(option)
        }
      })
      this.dispatchEvent(new CustomEvent('td:compare-set',{bubbles:true,detail: {collections: this.selectedOptions.map((option) => option.value)}}))
      this.updateContainerUI(true)
    }
    handleFiltersCleared() {
      this.selectedOptions = []
      this.options.forEach((option) => {
        option.checked = false
      })
    }
    handleExternalCompareSet({detail}) {
      this.selectedOptions = []
      this.options.forEach((option) => {
        if (detail.options.includes(option.value)) this.selectedOptions.push(option)
      })
      if (this.dataset.open == 'true') {
        this.updateContainerUI()
      } else { this.updateContainerUI(true) }
    }

    updateButtons() {
      if (this.selectedOptions.length > 0) {
        if (this.closeButton && !this.closeButton.classList.contains(this.BUTTON_HIDDEN_CLASS)) {
          this.closeButton.classList.add(this.BUTTON_HIDDEN_CLASS)
        }
        if (this.submitButton && this.submitButton.classList.contains(this.BUTTON_HIDDEN_CLASS)) {
          this.submitButton.classList.remove(this.BUTTON_HIDDEN_CLASS)
        }
        if (this.clearButton && this.clearButton.classList.contains(this.BUTTON_HIDDEN_CLASS)) {
          this.clearButton.classList.remove(this.BUTTON_HIDDEN_CLASS)
        }
      } else {
        if (this.closeButton && this.closeButton.classList.contains(this.BUTTON_HIDDEN_CLASS)) {
          this.closeButton.classList.remove(this.BUTTON_HIDDEN_CLASS)
        }
        if (this.submitButton && !this.submitButton.classList.contains(this.BUTTON_HIDDEN_CLASS)) {
          this.submitButton.classList.add(this.BUTTON_HIDDEN_CLASS)
        }
        if (this.clearButton && !this.clearButton.classList.contains(this.BUTTON_HIDDEN_CLASS)) {
          this.clearButton.classList.add(this.BUTTON_HIDDEN_CLASS)
        }
      }
    }

    updateContainerUI(ignoreDropdown = false) {
      if (!ignoreDropdown) {
        this.handleDropdown()
      }
      if (this.selectedOptions.length) {
        if (this.currentCountElement) {
          this.currentCountElement.innerHTML = `(${this.selectedOptions.length})`
        }
        if (this.activeCountElement) {
          this.activeCountElement.innerHTML = `(${this.selectedOptions.length})`
        }
        if (this.viewAllButton && this.viewAllButton.classList.contains(this.BUTTON_HIDDEN_CLASS)) {
          this.viewAllButton.classList.remove(this.BUTTON_HIDDEN_CLASS)
        }
      } else {
        if (this.activeCountElement) {
          this.activeCountElement.innerHTML = null
        }
        if (this.viewAllButton && !this.viewAllButton.classList.contains(this.BUTTON_HIDDEN_CLASS)) {
          this.viewAllButton.classList.add(this.BUTTON_HIDDEN_CLASS)
        }
      }
    }
  }


  customElements.define('td-dropdown-compare-container', TDCompareContainer)
}

if (!customElements.get('td-dropdown-sort-container')) {

  class TDSortContainer extends TDDropdownContainer {
    constructor() {
      super()

      this.OPTION_SELECTOR = '.td--sort-option__wrapper'
      this.TEXT_SELECTOR = '.td--sort-container__active-text'

      this.options = []
      this.selectedOption = ''
      this.textElement = undefined
    }
    initialize() {
      this.textElement = this.querySelector(this.TEXT_SELECTOR)
      this.options = this.querySelectorAll(this.OPTION_SELECTOR)
      if (this.textElement && this.options.length) {
        this.bindEventListeners()
      }
    }
    bindEventListeners() {
      this.options.forEach((elm) => elm.addEventListener('click', this.handleSortOptionSelected.bind(this)), true)
      document.addEventListener('td:update-sort-set', this.handleGlobalSortSet.bind(this))
      document.addEventListener('td:clear-all-filters', this.handleGlobalClearSort.bind(this))
    }
    handleSortOptionSelected({target}) {
      this.options.forEach((option) => {
        if (option == target || target.parentElement == option) {
          option.setAttribute('data-active', true)
          this.textElement.innerHTML = option.dataset.text
          this.selectedOption = option.dataset.value

        } else {
          option.setAttribute('data-active', false)
        }
      })
      this.dispatchEvent(new CustomEvent('td:sort-set',{bubbles:true,detail: {sort: this.selectedOption}}))
      this.handleDropdown()
    }
    handleGlobalSortSet({detail}) {
      this.options.forEach((option) => {
        if (option.dataset.value == detail.value) {
          option.setAttribute('data-active', true)
          this.textElement.innerHTML = option.dataset.text
          this.selectedOption = option.dataset.value
        } else {
          option.setAttribute('data-active', false)
        }
      })
    }
    handleGlobalClearSort() {
      this.options.forEach((option) => {
        option.setAttribute('data-active', false)
      })
      if (this.textElement) {
        this.textElement.innerHTML = ''
      }
      this.selectedOption = ''
      this.dispatchEvent(new CustomEvent('td:sort-set',{bubbles:true,detail: {sort: this.selectedOption}}))
    }
  }

  customElements.define('td-dropdown-sort-container', TDSortContainer)
}

class TDAccordionContainer extends HTMLElement {
  constructor() {
    super()
    this.CONTENT_SELECTOR = '.td--accordion-content'
    this.TRIGGER_SELECTOR = '.td--accordion-trigger'

    this.trigger = undefined
    this.content = undefined
    this.isOpen = false
  }
  connectedCallback() {
    setTimeout(() => {
      this.trigger = this.querySelector(this.TRIGGER_SELECTOR)
      this.content = this.querySelector(this.CONTENT_SELECTOR)
      if (this.trigger && this.content) {
        this.bindDropdownEvents()
        this.initialize()
      } else {
        console.error('TD - Accordion Container Missing Elements')
      }
      
    })
  }
  initialize() {
    // Stub
  }
  bindDropdownEvents() {
    this.trigger.addEventListener("click", this.handleDropdown.bind(this))
    document.addEventListener("td:acc-cont-opened", this.handleAccContOpened.bind(this))
    document.addEventListener('td:close-filter-accordions', () => {
      this.closeDropdown()
      this.updateDropdownState()
    })
  }
  handleDropdown() {
    if (!this.isOpen) {
      this.openDropdown()
    } else {
      this.closeDropdown()
    }
    this.updateDropdownState()
  }
  handleAccContOpened({detail}) {
    if (detail.elm !== this) {
      this.closeDropdown()
      this.updateDropdownState()
    }
  }
  openDropdown() {
    this.isOpen = true
    this.content.style.maxHeight = this.content.scrollHeight + "px";
    document.dispatchEvent(new CustomEvent('td:acc-cont-opened', {detail:{elm: this}}))
  }
  closeDropdown() {
    this.isOpen = false
    this.content.style.maxHeight = null
  }
  updateDropdownState() {
    this.setAttribute('data-open', this.isOpen)
  }
}
customElements.define('td-accordion-container', TDAccordionContainer)

if (!customElements.get('td-accordion-sort-container')) {

  class TDAccordionSortContainer extends TDAccordionContainer {
    constructor() {
      super()

      this.OPTION_SELECTOR = '.td--acc-sort-option__wrapper'
      this.TEXT_SELECTOR = '.td--sort-accordion__active-text'
      this.COMPARE_OPTION_SELECTOR = 'td-accordion-compare-container input'

      this.options = []
      this.selectedSortOptions = []
      this.selectedOption = ''
      this.textElement = undefined
    }
    initialize() {
      this.compareOptions = document.querySelectorAll(this.COMPARE_OPTION_SELECTOR)
      this.textElement = this.querySelector(this.TEXT_SELECTOR)
      this.options = this.querySelectorAll(this.OPTION_SELECTOR)
      if (this.textElement && this.options.length) {
        this.bindEventListeners()
      }
    }
    bindEventListeners() {
      this.options.forEach((elm) => elm.addEventListener('click', this.handleSortOptionSelected.bind(this)), true)
      document.addEventListener('td:update-sort-set', this.handleGlobalSortSet.bind(this))
      document.addEventListener('td:clear-all-filters', this.handleGlobalClearSort.bind(this))
    }
    getSelectedCompareOptions() {
      this.selectedSortOptions = []
      this.compareOptions.forEach((option) => {
        if (option.checked) {
          this.selectedSortOptions.push(option)
        }
      })
    }
    handleSortOptionSelected({target}) {
      this.options.forEach((option) => {
        if (option == target || target.parentElement == option) {
          option.setAttribute('data-active', true)
          this.textElement.innerHTML = option.dataset.text
          this.selectedOption = option.dataset.value

        } else {
          option.setAttribute('data-active', false)
        }
      })
      this.getSelectedCompareOptions()
      this.dispatchEvent(new CustomEvent('td:sort-set',{bubbles:true,detail: {collections: this.selectedSortOptions, sort: this.selectedOption}}))
    }
    handleGlobalSortSet({detail}) {
      this.options.forEach((option) => {
        if (option.dataset.value == detail.value) {
          option.setAttribute('data-active', true)
          this.textElement.innerHTML = option.dataset.text
          this.selectedOption = option.dataset.value
        } else {
          option.setAttribute('data-active', false)
        }
      })
    }
    handleGlobalClearSort() {
      this.options.forEach((option) => {
        option.setAttribute('data-active', false)
      })
      if (this.textElement) {
        this.textElement.innerHTML = ''
      }
      this.selectedOption = ''
      this.dispatchEvent(new CustomEvent('td:sort-set',{bubbles:true,detail: {sort: this.selectedOption}}))
    }
  }


  customElements.define('td-accordion-sort-container', TDAccordionSortContainer)
}

if (!customElements.get('td-accordion-compare-container')) {

  class TDAccordionCompareContainer extends TDAccordionContainer {
    constructor() {
      super()
      this.OPTION_SELECTOR = 'input'
      this.ACTIVE_ELM_SELECTOR = '.td--collection-accordion__active-text'

      this.activeCountElement = undefined
      this.options = []
      this.selectedOptions = []
    }
    initialize() {
      this.options = this.querySelectorAll(this.OPTION_SELECTOR)
      this.activeCountElement = this.querySelector(this.ACTIVE_ELM_SELECTOR)
      if (this.options.length) {
        this.bindEventListeners()
      } else {
        console.error('TD - Compare Container Missing Elements')
      }

    }
    bindEventListeners() {
      this.options.forEach((option) =>  option.addEventListener('click', this.handleOptionSelected.bind(this)))
      this.options.forEach((option) => option.addEventListener('change', this.handleOptionChange.bind(this,option)))
      document.addEventListener('td:clear-all-filters', this.handleFiltersCleared.bind(this))
      document.addEventListener('td:global-compare-set', this.handleExternalFilterUpdate.bind(this))
      document.addEventListener('td:update-compare-set', this.handleExternalCompareSet.bind(this))
    }
    handleOptionChange(option) {
      document.dispatchEvent(new CustomEvent('td:global-compare-set', {detail: {option}}))
    }
    handleExternalFilterUpdate({detail}) {
      const changedOption = detail.option
      const matchingOption = [...this.options].find((option) => option.value === changedOption.value)
      if (matchingOption) {
        matchingOption.checked = changedOption.checked
      }
      this.handleOptionSelected()
    }
    handleCompare() {
      this.selectedOptions = []
      this.options.forEach((option) => {
        if (option.checked) {
          this.selectedOptions.push(option)
        }
      })
      this.dispatchEvent(new CustomEvent('td:compare-set',{bubbles:true,detail: {collections: this.selectedOptions.map((option) => option.value)}}))
      this.updateContainerUI()
    }
    handleOptionSelected() {
      this.selectedOptions = []
      this.options.forEach((option) => {
        if (option.checked) {
          this.selectedOptions.push(option)
        }
      })
      this.updateContainerUI()
    }
    handleFiltersCleared() {
      this.selectedOptions = []
      this.options.forEach((option) => {
        option.checked = false
      })
      this.updateContainerUI()
    }
    updateContainerUI() {
      if (this.selectedOptions.length) {
        if (this.activeCountElement) {
          this.activeCountElement.innerHTML = `(${this.selectedOptions.length})`
        }
      } else {
        if (this.activeCountElement) {
          this.activeCountElement.innerHTML = null
        }
      }
      this.dispatchEvent(new CustomEvent('td:update-slide-out-collections',{bubbles:true,detail: {collections: this.selectedOptions.map((option) => option.value)}}))
    }

    handleExternalCompareSet({detail}) {
      this.selectedOptions = []
      this.options.forEach((option) => {
        if (detail.options.includes(option.value)) this.selectedOptions.push(option)
      })
      this.updateContainerUI()
    }
  }


  customElements.define('td-accordion-compare-container', TDAccordionCompareContainer)
}

if (!customElements.get('td-slideout-filters')) {

  class TDSlideoutFilters extends HTMLElement {
    constructor() {
      super()
      this.OVERLAY_SELECTOR = '.td--collection-list__slideout-overlay'
      this.CLOSER_SELECTOR = '.td--collection-list__slideout-closer'
      this.FILTER_TRIGGER_SELECTOR = '.td--collection-list__slideout-filter-trigger'
      this.FILTER_INDICATOR_SELECTOR = '.td--collection-list__slideout-filter-trigger-indicator'
      this.CLEAR_TRIGGER_SELECTOR = '.td--collection-list__slideout-clear-all'
      this.TEXT_SELECTOR = '.td--sort-accordion__active-text'
      this.CLOSE_SELECTOR = '.td--collection-list__slideout-close'
      this.FILTER_COUNT_SELECTOR = '.td--collection-list__slideout-filter-count'
      
      this.ACTIONS_SELECTOR = '.td--collection-list__slideout-footer'
      this.ACTIONS_SELECTOR_CLOSE = '.td--collection-list__slideout-footer--close'
      this.ACTIONS_MODIFIER_CLASS = 'td--collection-list__slideout-footer--hidden'
      this.COLLECTION_CARD_SELECTOR = '.td--acc-compare-option__wrapper'
      this.COLLECTION_CARDS_SELECTOR ='.td--collection-card__wrapper'
      
      this.overlay = undefined
      this.closer = undefined
      this.closeButton = undefined
      this.filterTrigger = undefined
      this.filterIndicator = undefined
      this.clearTrigger = undefined
      this.actionsContainer = undefined
      this.isOpen = false
      this.activeFilter = undefined
      this.allCollectionCards = undefined
      this.activeSort = 0

      this.activeCollections = []
      this.activeFilters = []
    }
    connectedCallback() {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(() => {
          this.allCards = document.querySelectorAll(this.COLLECTION_CARDS_SELECTOR)
          this.overlay = this.querySelector(this.OVERLAY_SELECTOR)
          this.closer = this.querySelector(this.CLOSER_SELECTOR)
          this.filterTrigger = this.querySelector(this.FILTER_TRIGGER_SELECTOR)
          this.filterIndicator = document.querySelectorAll(this.FILTER_INDICATOR_SELECTOR)
          this.filterCount = document.querySelector(this.FILTER_COUNT_SELECTOR)
          this.clearTrigger = this.querySelector(this.CLEAR_TRIGGER_SELECTOR)
          this.actionsContainer = this.querySelector(this.ACTIONS_SELECTOR)
          this.actionsContainerClose = this.querySelector(this.ACTIONS_SELECTOR_CLOSE)
          this.closeButton = this.querySelector(this.CLOSE_SELECTOR)
          this.allCollectionCards = document.querySelectorAll(this.COLLECTION_CARD_SELECTOR)

          document.addEventListener("td:slideout-open", this.handleSlideoutOpen.bind(this))

          if (this.overlay) {
            this.overlay.addEventListener('click', this.handleSlideoutClose.bind(this))
          }
          if (this.actionsContainer) {
            document.addEventListener('td:update-slide-out-collections', this.updateSlideoutCollections.bind(this))
            document.addEventListener('td:update-slide-out-filters', this.updateSlideoutFilters.bind(this))
            document.addEventListener('td:sort-set', ({detail}) => {
              if (detail.sort != '') {
                this.activeSort = 1
              } else {
                this.activeSort = 0
              }
              this.updateSlideoutUI()
            })
          }
          if (this.closer) {
            this.closer.addEventListener('click', this.handleSlideoutClose.bind(this))
          }
          if (this.closeButton) {
            this.closeButton.addEventListener('click', this.handleSlideoutClose.bind(this))
          }
          if (this.filterTrigger) {
            this.filterTrigger.addEventListener('click', this.handleFilterTriggerClick.bind(this))
          }
          if (this.clearTrigger) {
            this.clearTrigger.addEventListener('click', this.handleClearTriggerClick.bind(this))
          }
          window.addEventListener('resize', this.handleWindowResize.bind(this))
        })
      })
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.handleWindowResize)
    }
    handleWindowResize() {
      if (window.matchMedia("(min-width: 768px)").matches) {
        if (this.isOpen) [
          this.handleSlideoutClose()
        ]
      }
    }
    updateSlideoutFilters({detail}) {
      this.activeFilters = detail.type
      this.updateSlideoutUI()
    }
    updateSlideoutCollections({detail}) {
      this.activeCollections = detail.collections
      this.updateSlideoutUI()
    }
    handleSlideoutOpen() {
      if (!this.isOpen) {
        this.isOpen = true
        this.updateUIState()
      }
    }
    handleSlideoutClose() {
      if (this.isOpen) {
        this.isOpen = false
        this.updateUIState()
        document.dispatchEvent(new CustomEvent('td:close-filter-accordions'))
      }
    }
    handleFilterTriggerClick() {
      this.dispatchEvent(new CustomEvent('td:compare-set', {bubbles:true, detail: {collections: this.activeCollections}}))
      this.dispatchEvent(new CustomEvent('td:filter-set', {bubbles:true, detail: {type: this.activeFilters}}))
      this.handleSlideoutClose()
    }
    updateSlideoutUI() {
      this.activeFilter = document.querySelector(this.TEXT_SELECTOR) || ''
      let count = this.getCount()

      if (this.activeCollections.length > 0 || this.activeFilters.length > 0) {
        this.actionsContainerClose.classList.add(this.ACTIONS_MODIFIER_CLASS)
        this.actionsContainer.classList.remove(this.ACTIONS_MODIFIER_CLASS)
        if (this.filterCount) {
          this.filterCount.innerHTML = `(${this.activeSort + this.activeFilters.length})`
        }
        if (this.filterIndicator.length > 0) {
          this.filterIndicator.forEach((indicator) => {
            indicator.innerHTML = `(${count})`
          })
        }
      } else if (this.activeSort > 0) {
        this.actionsContainerClose.classList.add(this.ACTIONS_MODIFIER_CLASS)
        this.actionsContainer.classList.remove(this.ACTIONS_MODIFIER_CLASS)
        if (this.filterCount) {
          this.filterCount.innerHTML = `(${this.activeSort + this.activeFilters.length})`
        }
        if (this.filterIndicator.length > 0) {
          this.filterIndicator.forEach((indicator) => {
            indicator.innerHTML = `(${count})`
          })
        }
      }
      else {
        this.actionsContainer.classList.add(this.ACTIONS_MODIFIER_CLASS)
        this.actionsContainerClose.classList.remove(this.ACTIONS_MODIFIER_CLASS)
      }
    }
    getCount() {
      let count = 0
      if (this.allCards.length > 0) {
        if (this.activeCollections.length > 0) {
          this.allCards.forEach((card) => {
            if (this.activeCollections.includes(card.dataset.title)) {
              count++
            }
          })
        } else if (this.activeFilters.length > 0) {
          this.allCards.forEach((card) => {
            if (this.activeFilters.includes(card.dataset.type)) {
              count++
            }
          })
        } else {
          count = this.allCards.length
        }       
        return count
      }
    }
    handleClearTriggerClick() {
      this.dispatchEvent(new CustomEvent('td:compare-set', {bubbles:true, detail: {collections: []}}))
      this.dispatchEvent(new CustomEvent('td:filter-used', {bubbles:true, detail: {type: []}}))
      document.dispatchEvent(new CustomEvent('td:clear-all-filters'))
      if (this.filterCount) {
        this.filterCount.innerHTML = ''
      }
      if (this.filterIndicator.length > 0) {
        this.filterIndicator.forEach((indicator) => {
          indicator.textContent = ''
        })
      }
      this.handleSlideoutClose()
    }
    updateUIState() {
      this.setAttribute('data-open', this.isOpen)
      document.firstElementChild.classList.toggle('overflow-hidden', this.isOpen)
    }
  }

  customElements.define('td-slideout-filters', TDSlideoutFilters)
}